import { useEffect, useState } from "react";
import { columnsheadId } from "../../universal/columnshead";
import MenuSpecUploadFileEdit from "./MenuSpecUploadFileEdit";
import systemExpand from "../../../config/systemExpand";
import UploadFileListUniversal, { UFLUExtendPropsType } from "../../system/UploadFileListUniversalNewEx";

//组件 MenuSpecUploadFile
export default function MenuSpecUploadFile(props: any) {

    //extendProps 
    const [extendProps, setExtendProps] = useState<UFLUExtendPropsType>();

    //表头
    const columnsHead = [
        {
            title: '菜式',
            dataIndex: 'foodName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.menuSpec.menu.foodName}</div>
                )
            }
        },
        {
            title: '规格',
            dataIndex: 'menuSpecName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.menuSpec.menuSpecName}</div>
                )
            }
        },
        // {
        //     title: '腾讯视频',
        //     dataIndex: 'movieId',
        // },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
    ];

    const filesColumns = columnsheadId
        .concat(columnsHead as []);

    useEffect(() => {
        systemExpand.getConfig({
            id: 'config',
            nodeId: 'files'
        }).then(res => {
            const { files } = res as any;
            const { menuSpecFilesGroupId } = files;
            setExtendProps({
                ...props,
                titleName: '菜式规格图片',
                apiId: 'menuSpec',
                filesGroupId: menuSpecFilesGroupId,
                fileType: "files",
                //+ File
                //上传 + UploadFile
                //删除 + DeleteFile
                filesColumns,
                showImage: true,
                showDownload: props.data.extendObj.isPromoCategory ? false : true,
                showStates: props.data.extendObj.isPromoCategory ? false : true,
                showDefault: props.data.extendObj.isPromoCategory ? false : true,
                showPromo: sessionStorage.getItem('isAdmin') === 'true' ? true : false,
                showFileUpload: sessionStorage.getItem('isAdmin') === 'true' ? true : false,
                showFileSelection: props.data.extendObj.isPromoCategory ? false : true,
                showOperation: props.data.extendObj.isPromoCategory ? false : true,
                extendIdName: "menuSpecId",
                EditComponent: MenuSpecUploadFileEdit,
                disableCheckBox: sessionStorage.getItem('isAdmin') === 'true' ? false : true
            })
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (extendProps) {
        return (
            <UploadFileListUniversal props={extendProps} />
        )
    }
}